<template>
  <div class="game-page">
    <header class="game-page-header">
      <button
        type="button"
        class="game-page-back"
        @click="goBack"
        :aria-label="$store.state.language === 'en' ? 'Go back' : 'နောက်သို့'"
      >
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
      </button>
      <div class="game-page-heading">
        <h1 class="game-page-title">{{ displayProviderName }}</h1>
        <p class="game-page-meta">
          {{ displayGames.length }}
          {{ $store.state.language === 'en' ? 'games' : 'ဂိမ်း' }}
        </p>
      </div>
      <div class="game-page-search-field">
        <i class="fas fa-search game-page-search-icon" aria-hidden="true"></i>
        <input
          v-model="name"
          type="search"
          enterkeyhint="search"
          autocomplete="off"
          class="game-page-search"
          :placeholder="$t('home.search_game')"
        />
      </div>
    </header>

    <section class="game-page-body">
      <div v-if="showEmpty" class="game-page-empty">
        <i class="fas fa-gamepad" aria-hidden="true"></i>
        <template v-if="$store.state.language === 'en'">
          No games match your search. Try another name.
        </template>
        <template v-else>
          ရှာဖွေမှုနှင့် ကိုက်ညီသော ဂိမ်းမရှိပါ။ အခြားစာသားဖြင့် စမ်းကြည့်ပါ။
        </template>
      </div>

      <div v-else class="game-page-grid">
        <button
          v-for="(game, index) in displayGames"
          :key="game.gameID + '-' + index"
          type="button"
          class="game-page-card"
          @click="gameInit(game)"
        >
          <div class="game-page-card__thumb">
            <img
              :src="imageLinkGenerate(game.gameID, game)"
              :alt="game.gameName"
              loading="lazy"
            />
          </div>
          <span class="game-page-card__name">{{ game.gameName }}</span>
        </button>
      </div>
    </section>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { openGameInIframe } from '@/libs/openGameInIframe';
import { thumbnailUrlGameId } from '@/libs/thumbnailGameId';

export default {
  data() {
    return {
      games: [],
      rows: 0,
      provider: 'Pragmatic',
      name: null,
      newGames: [],
      isMobile: false,
      option1: [
        { text: 'Pragmatic Play', value: 'Pragmatic' },
        { text: 'Jili', value: 'Jili' },
        { text: 'Play Star', value: 'Playstar' },
        { text: 'Fast Spin', value: 'Fastspin' },
        { text: 'Spade Gaming', value: 'Spade' },
      ],
    };
  },
  computed: {
    displayProviderName() {
      const p = this.$route.query.provider || this.provider;
      if (p === 'Pragmatic') return 'Pragmatic Play';
      return p || 'Games';
    },
    displayGames() {
      return this.newGames.length > 0 ? this.newGames : this.games;
    },
    showEmpty() {
      return this.displayGames.length === 0;
    },
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/home');
      }
    },
    ...mapActions(['fetchUser']),
    imageLinkGenerate(gameId, game = null) {
      const type = this.$route.query.provider;
      const id = thumbnailUrlGameId(gameId, type, game);
      if (type === 'Jili') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jili/${id}.webp`;
      }
      if (type === 'Live22') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/live22/${id}.webp`;
      }
      if (type === 'Spade') {
        return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${id}.jpg`;
      }
      if (type === 'Fastspin') {
        return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${id}.jpg`;
      }
      if (type === 'Playstar') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/playstar/${id}.webp`;
      }
      if (type === 'FaChai') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/fachai/${id}.webp`;
      }
      if (type === 'PGSoft') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/pgsoft_${id}.webp`;
      }
      if (type === 'JOKER' || type === 'Joker') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${id}.webp`;
      }
      if (type === '5G') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/5g/${id}.webp`;
      }
      if (type === 'KA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/newKA/${id}.webp`;
      }
      if (type === 'AceWin') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/acewin/${id}_EN.webp`;
      }
      if (type === 'JDB') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jdb/${id}.webp`;
      }
      if (type === 'Buffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${id}.webp`;
      }
      if (type === 'HotDog') {
        return `https://res.hotdog-gaming.com/banners/380x500/${id}.png`;
      }
      if (type === 'Rich') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich/${id}.webp`;
      }
      if (type === 'Rich88') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich88/${id}.webp`;
      }
      if (type === 'CQ9' || type === 'cq9' || type === 'SexySlot') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/cq9/cq9_${id}.webp`;
      }
      if (type === 'BTG') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/btg/${id}.webp`;
      }
      if (type === '2J') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/2j/${id}.webp`;
      }
      if (type === 'VA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/va/${id}_en.webp`;
      }
      if (type === 'BNG'){
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/bng/${id}.webp`;
      }
      if (type === 'AfricanBuffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/${id}.webp`;
      }

      return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${id}.webp`;
    },
    async fetchGames() {
      try {
        const res = await axios.get('/games', {
          params: {
            provider: this.$route.query.provider,
          },
        });

        this.games = res.data.data;
        this.games = this.games.filter((game) => game.gameTypeID.includes('ac'));
      } catch (error) {
        console.log(error);
      }
    },

    async gameInit(game) {
      try {
        this.$store.commit('setLoading', true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const res = await axios.get('/games/url', {
          params: {
            gameID: game.gameID,
            provider: this.$route.query.provider,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const gameUrl = res.data?.data?.gameUrl;
        if (!gameUrl) {
          this.$store.commit('setLoading', false);
          return;
        }

        openGameInIframe(this.$router, this.$store, gameUrl, {
          providerName: this.displayProviderName,
          gameName: game.gameName,
        });

        this.$store.commit('setLoading', false);
      } catch (error) {
        this.$store.commit('setLoading', false);
      }
    },
    isPWA() {
      return (
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true ||
        document.referrer.startsWith('android-app://')
      );
    },
  },
  watch: {
    provider() {
      this.fetchGames();
    },
    name() {
      const q = (this.name || '').toLowerCase().trim();
      if (!q) {
        this.newGames = [];
        return;
      }
      this.newGames = this.games.filter((game) => game.gameName.toLowerCase().includes(q));
    },
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
    await this.fetchGames();
    this.$store.commit('setLoading', false);
  },
};
</script>
<style scoped>
</style>
